import { render, staticRenderFns } from "./customPagination.vue?vue&type=template&id=fedec55a&scoped=true&"
import script from "./customPagination.vue?vue&type=script&lang=js&"
export * from "./customPagination.vue?vue&type=script&lang=js&"
import style0 from "./customPagination.vue?vue&type=style&index=0&id=fedec55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedec55a",
  null
  
)

export default component.exports